import classNames from 'classnames'
import { useField } from 'formik'
import { useCallback } from 'react'

const RadioButton = ({
  field,
  placeholder,
  onClick,
  checked,
  disabled,
  showValidationErrors,
  inputClassName,
}) => {
  const [selectField, selectMeta, selectHelpers] = useField(
    field.name
  )
  const { name } = selectField

  const handleOnChange = useCallback(
    (value) => {
      selectHelpers.setValue(value)
      onClick(value)
    },
    [selectHelpers]
  )

  return (
    <>
      <label
        className={classNames(
          { '-disabled': disabled },
          { '-error': showValidationErrors && !selectField.value },
          { '-checked': checked }
        )}
      >
        <input
          id={name}
          checked={checked}
          name={name}
          type="radio"
          onChange={() => handleOnChange(!field.value)}
          disabled={disabled}
          className={classNames(inputClassName, {
            '-error': showValidationErrors && !selectField.value,
          })}
        />
        {placeholder}
      </label>
    </>
  )
}

export default RadioButton
